import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import App from './App.tsx'
import CallbackHandler from './components/CallbackHandler'
import './index.css'
import { Toaster } from 'react-hot-toast'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/callback" element={<CallbackHandler />} />
        <Route path="/*" element={<App />} />
      </Routes>
      <Toaster 
        position="top-center"
        toastOptions={{
          style: {
            background: '#1E1E1E',
            color: '#FFFFFF',
            border: '1px solid #333333',
            borderRadius: '8px',
          },
          success: {
            iconTheme: {
              primary: '#1DB954',
              secondary: '#FFFFFF',
            },
          },
          error: {
            iconTheme: {
              primary: '#E74C3C',
              secondary: '#FFFFFF',
            },
          },
        }}
      />
    </BrowserRouter>
  </React.StrictMode>,
) 